import React from 'react';
import {
  shape,
  func,
  string,
  bool,
} from 'prop-types';
import {
  Select,
  SelectOption,
  Label,
} from '@americanexpress/dls-react';
import { useReactlytics } from '@americanexpress/reactlytics';

const MenuDropDown = ({
  menu, updateDestination, dropRef, selectLabel, isDisabled,
}) => {
  const { track } = useReactlytics();

  const onSelect = (event) => {
    updateDestination();
    track({
      event: {
        element: 'Login_SelectDestination',
        detail: event.target.value,
        type: 'click',
      },
    });
  };

  return (
    <div>
      <Label id="eliloAccountType-label" htmlFor="eliloSelect">{selectLabel}</Label>
      <Select
        data-testid="menu-dropdown"
        ref={dropRef}
        className="form-group"
        onChange={onSelect}
        aria-labelledby="eliloAccountType-label"
        reactlytics={{ disable: true }}
        fluid={true}
        disabled={isDisabled}
      >
        {menu.map(({
          key, url, label, brandname, sso,
        }) => (
          <SelectOption
            data-testid={key}
            key={key}
            url={url}
            value={key}
            brandname={brandname}
            sso={sso}
          >
            {label}
          </SelectOption>
        ))}
      </Select>
    </div>
  );
};

MenuDropDown.propTypes = {
  menu: shape({}),
  dropRef: shape({}),
  updateDestination: func,
  selectLabel: string,
  isDisabled: bool,
};

export default MenuDropDown;
